// Converts { 1: 'test', 2: 'example' } into ['test', 'example'].
// Adapted from https://script.google.com/a/prenetics.com/d/1tS658l5K0F_gLCLDzyE3mRu8FXHhUkr5jGUVUtmmQVrq5qYsg0h5R97b/edit
// TODO: marketing site should use this Google script to import copytable and
// automatically convert all objects with numeric keys into arrays.
export function convertNumericKeysToArray(element: object | string | undefined | null): any {
  if (typeof element !== 'object' || element === null) {
    return element;
  }

  const keys = Object.keys(element);

  let isAllNumeric = keys.reduce((allNumeric, key) => {
    if (isNaN(Number(key))) {
      allNumeric = false;
    }

    if (hasKey(element, key)) {
      element[key] = convertNumericKeysToArray(element[key]);
    }

    return allNumeric;
  }, true);

  if (isAllNumeric) {
    return keys
      .map(key => hasKey(element, key) ? element[key] : undefined)
      .filter(isNotUndefined);
  }

  return element;
}

function hasKey<V extends string>(
  obj: Record<V, any> | Record<V, undefined>,
  key: V,
): obj is Record<V, any> {
  return obj[key] !== undefined;
}

export const isNotUndefined = <T>(thing: T | undefined): thing is T => thing !== undefined;
